import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const greyLight = constants.colors.ui.neutral[50];

export const tabPanelAdjustmentsCss: CSSObject = {
  marginTop: "inherit",
};

const disableTabsCss: CSSObject = {
  pointerEvents: "none",
  cursor: "not-allowed",
  opacity: "0.6",
};

export const tabListCss = (isLoading: boolean): CSSObject => ({
  zIndex: 3,
  paddingInline: "32px",
  borderBottom: `1px solid ${greyLight}`,
  width: "100%",
  ...(isLoading ? disableTabsCss : {}),
});

export const tabPanelsCss: CSSObject = {
  paddingTop: 0,
};
